import { render } from "./FrontendCookiesComponent.vue?vue&type=template&id=da7610c8"
import script from "./FrontendCookiesComponent.vue?vue&type=script&lang=js"
export * from "./FrontendCookiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/layouts/frontend/FrontendCookiesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da7610c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da7610c8', __exports__)) {
    api.reload('da7610c8', __exports__)
  }
  
  module.hot.accept("./FrontendCookiesComponent.vue?vue&type=template&id=da7610c8", () => {
    api.rerender('da7610c8', render)
  })

}


export default __exports__